<template>
    <Head>
        <title>{{title}}</title>
        <meta name="description" :content="description">
    </Head>
    <div class="layout-container max-w-full">
        <div>
            <B2BTopBar/>
        </div>
        <main>
            <slot/>
        </main>
        <Footer/>
    </div>
    <CitySelector/>
    <MobileProfileMenu/>
    <OnlyMobile :maxSize="1024">
        <MobileMenu/>
        <MobileNav/>
        <MobileSearchPopup/>
    </OnlyMobile>
    <BaseCallback/>
    <OnlyDesktop :maxSize="1024">
        <SpeedDial/>
    </OnlyDesktop>
    <CookieAccept/>
    <Toast/>
</template>

<script>
import {Head, router} from '@inertiajs/vue3';
import TopBar from "@js/components/TopBar/TopBar.vue";
import OnlyMobile from "@js/components/DynamicComponents/OnlyMobile.vue";
import MobileNav from "@js/components/Mobile/MobileNav.vue";
import Toast from "@js/components/Toast/Toast.vue";
import Footer from "@js/components/Footer/Footer.vue";
import MobileMenu from "@js/components/Mobile/MobileMenu.vue";
import OnlyDesktop from "@js/components/DynamicComponents/OnlyDesktop.vue";
import {useMenuStore} from "@js/store/MenuStore.js";
import MobileSearchPopup from "@js/components/Search/MobileSearchPopup.vue";
import {useCartStore} from "@js/store/CartStore.js";
import SpeedDial from "@js/components/Widgets/SpeedDial.vue";
import CookieAccept from "@js/components/Widgets/CookieAccept.vue";
import BaseCallback from "@js/components/Callbacks/BaseCallback.vue";
import CitySelector from "@js/components/Popup/CitySelector.vue";
import {useThemeStore} from "@js/store/ThemeStore.js";
import MobileProfileMenu from "@js/components/Mobile/MobileProfileMenu.vue";
import B2BTopBar from "@js/Pages/B2B/B2BTopBar.vue";
import {onBeforeUnmount, onMounted} from "vue";
import {useJivoStore} from "@js/store/JivoStore.js";

export default {
    name: "PartnershipLayout",
    components: {
        B2BTopBar,
        MobileProfileMenu,
        CitySelector,
        BaseCallback,
        CookieAccept,
        SpeedDial,
        MobileSearchPopup,
        OnlyDesktop,
        MobileMenu,
        Head,
        Footer,
        Toast,
        MobileNav,
        OnlyMobile,
        TopBar
    },
    props: {
        title: String,
        description: String,
        menuItems: {
            required: true,
        }
    },
    mounted() {
        router.on("before", (event) => {
            this.menuStore.closeSidenav()
            this.menuStore.closeProfileSidenav()
        })
    },
    setup(props) {
        const cartStore = useCartStore()
        const menuStore = useMenuStore()
        const themeStore = useThemeStore()
        const jivoStore = useJivoStore()

        onMounted(() => {
            jivoStore.init()
        })

        onBeforeUnmount(() => {
            jivoStore.teardown()
        })

        return {
            menuStore,
            cartStore,
            themeStore
        }
    }
}
</script>

<style lang="scss" scoped>
.layout-container {
    display: flex;
    flex-direction: column;
    min-height: 100vh;


    main {
        flex: 1;
    }
}
</style>
